export default "__VITE_ASSET__BHampgoH__"